import { DisableBlock } from 'common/common-styles'
import { LastActivity, MetaValue } from './styles'
import ProgressPill from 'components/ProgressPill/ProgressPill'

export const getActivityText = (row: any) => {
  if (row.lastActivity) {
    return (
      <LastActivity>
        Last Activity <br /> {row.lastActivity}
      </LastActivity>
    )
  }

  if (!row.isStarted) {
    return (
      <LastActivity>
        Date Started <br /> Not Yet
      </LastActivity>
    )
  }

  if (row.disabled || !row.lastActivity) {
    return (
      <div className='flex-col'>
        <DisableBlock />
        <DisableBlock width={46} style={{ marginTop: 5 }} />
      </div>
    )
  }
}

export function getProgressPercentageBars(row: any) {
  if (row.progressPercentage || row.progressPercentage === 0) {
    return (
      <ProgressPill
        fill={row.progressPercentage}
        percentage={row.progressPercentage}
        showFillLabel
        compact
        disabled={false}
        bottomLabel={row.answeredText}
      />
    )
  }

  if (row.disabled) {
    return (
      <>
        <DisableBlock />
        <DisableBlock width={46} />
      </>
    )
  }
}

export function getScoreText(row: any) {
  const numericScore = row.score?.includes('%')
    ? row.score.split('%')[0]
    : row.score

  if (numericScore || numericScore === 0) {
    return <MetaValue>{numericScore}%</MetaValue>
  }

  if (row.disabled || numericScore === null || numericScore === '') {
    return (
      <div className='flex'>
        <DisableBlock width={31} height={18} radius={10} />
      </div>
    )
  }
}

export function getTimeSpentText(row: any) {
  if (row.timeSpent) {
    return <MetaValue>{row.timeSpent}</MetaValue>
  }

  if (row.disabled) {
    return (
      <div className='flex'>
        <DisableBlock width={31} height={18} radius={10} />
      </div>
    )
  }
}
